<template>
  <div class="athletes_photo" style="width:1050px">
    <header>
      <h1>{{details.matchName}}</h1>
      <h2>{{userInfo.schoolName}}大学生参赛运动员</h2>
    </header>
    <template v-for="item in getShowNum">
      <div :key="item">
        <div class="top" style="width:100%;display:flex">
          <div
            :style="{borderRight:(index+1) == 9 ?'none':'1px solid #999'}"
            style="width:116.5px;box-sizing:border-box;flex-shrink: 0;"
            v-for="(temp,index) in details.athleteList.slice((item - 1) * 9,item * 9)"
            :key="index + '_' + item"
          >
            <div style="display:flex;justify-content:center;align-items:center;">
              <section style="padding:10px;">
                <img :src="temp.headImage" style="width:90px;height:100px;" alt />
              </section>
            </div>
          </div>
        </div>
        <div class="bottom" style="width:100%;display:flex">
          <div
            :style="{borderRight:index + 1 === 9?'none':'1px solid #999',borderBottom:item === getShowNum?'none':'1px solid #999'}"
            style="width:116.5px;flex-shrink: 0;display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #999;border-left:none;padding:10px;"
            v-for="(temp,index) in details.athleteList.slice((item - 1) * 9,item * 9)"
            :key="index + '-' + item"
          >
            <p style="margin-bottom:10px;font-size:18px;color:#444;display:flex;">
              <span :style="{marginRight:temp.signNumber?'16px':''}">{{temp.signNumber}}</span>
              <span style="max-width:110px;">{{temp.athleteName}}</span>
            </p>
            <p style="margin:0;padding:0;;white-space: normal;word-break: break-all;word-wrap: break-word;">{{temp.registerNumber}}</p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage.js";
export default {
  props: {
    details: {
      type: Object
    }
  },
  data() {
    return {
      userInfo: JSON.parse(getSession("userInfo")) || ""
    };
  },
  computed: {
    getShowNum() {
      let num = 0;
      if (this.details.athleteList && this.details.athleteList.length < 9) {
        num = 1;
      } else if (
        this.details.athleteList &&
        this.details.athleteList.length >= 9
      ) {
        let length = this.details.athleteList.length;
        if (length / 9 > parseInt(length / 9)) {
          num = parseInt(length / 9) + 1;
        } else {
          num = length / 9;
        }
      }
      return num;
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.athletes_photo {
  border: 1px solid #999;
  > header {
    text-align: center;
    padding: 44px 0;
    color: #444;
    font-weight: 600;
    border-bottom: 1px solid #999;
    > h1 {
      font-size: 24px;
      margin-bottom: 14px;
    }
    > h2 {
      font-size: 22px;
    }
  }
}
</style>